// 앱 시작점

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역
import React, { // 리액트 베이스
  useEffect, // 상태 변경 이벤트 헨들러
  useState, // 내부 상태 관리 훅
  useRef, // 객체 참조자
  forwardRef,
  Fragment, // 재사용 가능한 라이브러리 컴포넌트에서, 자식 중 하나에 ref를 전달
  useCallback, // 상태 변경시까지 함수 재사용 장치 // 재사용 가능한 라이브러리 컴포넌트에서, 자식 중 하나에 ref를 전달
} from 'react';
// import M from 'src/com/keymansco/chihuahuaone/helper/mainHelper'; // 메인 헬퍼
import M from 'src/com/keymansco/chihuahuaone/helper/mainHelper'; // 메인 헬퍼
// import atom from 'src/com/keymansco/chihuahuaone/atom/index'; // 원자 컴포넌트
// import molecule from 'src/com/keymansco/chihuahuaone/molecule/index'; // 분자 컴포넌트
// import organism from 'src/com/keymansco/chihuahuaone/organism/index'; // 업무 컴포넌트
// import template from 'src/com/keymansco/chihuahuaone/template/index'; // 템플릿 컴포넌트
// import page from 'src/com/keymansco/chihuahuaone/page/index'; // 페이지 컴포넌트

// 동적 영역
import {
  NativeBaseProvider, // 네이티브 베이스 제공자 [앱 루트에 배치. 테마, 설정 등]
} from 'native-base';
import {
  LinearGradient, // expo환경 선형 그라데이션
} from 'expo-linear-gradient';
// import StorybookUI from 'src/../storybook'; // 스토리북 관리 페이지
// import atom from 'src/com/keymansco/chihuahuaone/atom';
import { LogBox } from 'react-native';
import NavigationDecorator from 'src/../NavigationDecorator'; // 네비게이션 데코레이터

// =================================================================================================
// 상수
// =================================================================================================
// 일부 경고 메시지 화면상 숨김 처리
LogBox.ignoreLogs(['Require cycle:']);

M.localization.setup(); // 다국어 설정

// =================================================================================================
// 컴포넌트 정의
// =================================================================================================
const App = forwardRef((props, ref) => {
  // 내부 상태 [컴포넌트 자체 뷰 갱신 전용. private.]
  // const [number, setNumber] = useState(0);

  // 외부 상태 [외부 개방용. public.]
  // let P = App; // P 자동완성용
  let P = props; // 속성. 읽기전용.

  // 참조 변수
  // const domRef = useRef(null);

  // 상수

  // =================================================================================================
  // 컨테이너 컴포넌트 이벤트 핸들러
  // =================================================================================================
  // 컴포넌트 미운트 시 [componentDidMount, componentDidUpdate] [인자값 변경시 동작] [빈 배열 적용시 최초 마운트 때 한번 동작]
  useEffect(() => {
    M.log.info('Home');

    // 컴포넌트 언마운트 시(componentWillUnmount)
    return () => {};
  }, []);

  // =================================================================================================
  // 컴포넌트 함수 정의
  // =================================================================================================

  // =================================================================================================
  // 그리기
  // =================================================================================================
  const renderNavigationDecorator = () => {
    return (
      <NavigationDecorator // 네비게이션 데코레이터
        initialRouteName="Intro"
      ></NavigationDecorator>
    );
  };

  // 렌더링(render)
  return (
    <NativeBaseProvider // 앱 전체에서 테마를 사용할 수 있도록 하는 구성 요소. 앱의 루트에 추가
      {...P}
      ref={ref}
      theme={
        M.theme // 네이티브베이스 앱 확장 테마
      } // 앱 확장 테마 (nativebase 베이스)
      config={{
        // 설정
        dependencies: {
          // 의존성
          'linear-gradient': LinearGradient, // css의 linear-gradient 대응 컴포넌트 셋
        },
      }}
      style={{
        // 인라인 스타일 [스타일 분리시, 모양새 추정에 불리.]
        ...P.style,
      }}
    >
      {renderNavigationDecorator()}
    </NativeBaseProvider>
  );
});

// =================================================================================================
// 내보내기
// =================================================================================================
export default M.const.isDevMode() // 개발 모드 이면, 스토리북 내보내기.
  ? App // StorybookUI
  : App; // 제품 모드 이면, 앱 내보내기.
